// Save to playlist (Sep 2026): the tune on screen was opened from a playlist
// row, so how it plays now — key, tempo, feel, choruses, form, ending — can be
// saved as that row's call, which everyone opening the tune from the playlist
// then plays with. Shown in Tune details and the playlist popover; the buttons
// only where the playlist is yours to change.

import { canEditPlaylist } from '@/storage/playlistLinks';
import { playlistCallOf, playlistCallRow, useStore } from '@/state/store';
import { sameCall } from '@/state/tunePlayback';
import { playlistCallSummary } from './playlistCall';

export function PlaylistCallControls({
  onNotice,
  inPlaylistPanel = false,
}: {
  onNotice?: (message: string) => void;
  /** In the playlist popover, which already names the playlist. */
  inPlaylistPanel?: boolean;
}) {
  const list = useStore((s) => playlistCallRow(s)?.list);
  const entry = useStore((s) => playlistCallRow(s)?.entry);
  const editable = useStore((s) =>
    s.playlistCallSource
      ? canEditPlaylist(s.playlistLinks, s.playlistCallSource.playlistId)
      : false,
  );
  const changed = useStore((s) => {
    const row = playlistCallRow(s);
    return !!row && !sameCall(playlistCallOf(s), row.entry.call);
  });
  const save = useStore((s) => s.savePlaylistCall);
  const clear = useStore((s) => s.clearPlaylistCall);

  if (!list || !entry) return null;
  const call = entry.call;
  return (
    <div className="tune-playback playlist-call" data-testid="playlist-call">
      <div className="tune-playback-row">
        <span className="tune-playback-label">{inPlaylistPanel ? 'This tune' : 'Playlist'}</span>
        {!inPlaylistPanel && (
          <span className="tune-playback-state playlist-call-name" data-testid="playlist-call-name">
            {list.name}
          </span>
        )}
      </div>
      {call && (
        <p className="playlist-call-summary" data-testid="playlist-call-summary">
          {playlistCallSummary(call)}
        </p>
      )}
      {editable && (
        <div className="tune-playback-row">
          <button
            type="button"
            className="btn btn-sm btn-primary"
            data-testid="playlist-call-save"
            disabled={!changed}
            onClick={() => {
              if (save()) onNotice?.(`Saved to ${list.name}`);
            }}
          >
            {call && !changed ? 'Saved' : 'Save to playlist'}
          </button>
          {call && (
            <button
              type="button"
              className="btn btn-sm btn-ghost"
              data-testid="playlist-call-clear"
              onClick={clear}
            >
              Clear
            </button>
          )}
        </div>
      )}
    </div>
  );
}
